import React, { FC } from "react";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";

interface CommonLoaderProps {
  loadingMessage?: string;
}

const CommonLoader: FC<CommonLoaderProps> = ({ loadingMessage }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="60vh"
    >
      <Box textAlign="center">
        <CircularProgress size={50} thickness={4} />

        <Paper
          elevation={0}
          sx={{
            mt: 3,
            p: 3,
            borderRadius: 1
          }}
        >
          <Typography variant="body1">
            {loadingMessage || "Fetching..."}
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
};

export default CommonLoader;
